var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSms = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "66px",
    viewBox: "0 0 71 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 509") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_CompanyDESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM-DashBoard",
    transform: "translate(-709.000000, -1220.000000)",
    fill: "#00142D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-509",
    transform: "translate(709.000000, 1220.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.90675,0.634625 C16.6071667,0.634625 0.90675,13.567125 0.90675,29.4600417 C0.90675,36.964625 4.33966667,43.999625 10.6046667,49.3837917 L3.5755,63.415875 C2.95425,64.658375 4.26675,65.9737917 5.49466667,65.3904583 L24.26925,56.6550417 C27.9996667,57.7342083 31.908,58.2825417 35.90675,58.2825417 C55.2063333,58.2825417 70.90675,45.3529583 70.90675,29.4600417 C70.90675,13.567125 55.2063333,0.634625 35.90675,0.634625",
    id: "Fill-260"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSms);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms.0fb5a3e87b96037eaaefe4667b3f3123.svg";